<template>
    <div class="tag-lists flex items-center flex-wrap">
        <template v-for="(item, index) in infoList">
            <div v-if="showItem(item)" class="tag-item" :key="item.path">
                <el-link :type="$route.path === item.path ? 'primary' : 'default'" @click="tagClick(item)">{{ item.name }}</el-link>
                <el-divider v-if="index + 1 < infoList.length" direction="vertical"></el-divider>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'MenusTagList',
    props: {
        list: {
            type: Object,
            default() {
                return {}
            }
        },
        routeType: { // 路由类型 1: 卡首屏系列 2: 手淘卡屏
            type: [Number, String],
            default: 1
        }
    },
    data() {
        return {}
    },
    computed: {
        infoList() {
            return Object.values(this.list)
        }
    },
    methods: {
        // 是否展示 item-tag
        showItem(item) {
            // 手动隐藏
            if (item.hidden) {
                return false
            }

            // 当前渲染的 routeType 和传入的 routeType 不同 则不需要渲染
            if (+item.routeType !== +this.routeType) {
                return false
            }

            return true
        },

        // tag 点击跳转
        tagClick(item) {
            this.$router.push({
                path: item.path
            })
        },
    }
}
</script>

<style scoped lang="scss">
.tag-lists {
    padding: 6px 20px;

    .tag-item {
        margin: 4px 0;
    }
}
</style>
